import { connect } from 'react-redux';
import React, { Component } from 'react';

import PropTypes from 'prop-types';
import { activeClass } from '../../table/table-utils';
import { TABLE_TYPES } from '../../table/constants/table-options';
import {
    exportToCSVFailure,
    exportToCSVSuccess,
    resetWidgetTableColumn,
    toggleWidgetTableColumn
} from '../../dashboard/actions/dashboard-action-creators';
import {
    initializeMySendersWidget
} from './my-sender-action-creators';
import {
    isActiveRightPaneSelector,
} from '../../common/selectors/right-pane-selectors';
import { isExportingGridToCsvSelector } from '../../dashboard/selectors/widget-selectors';
import { mySendersAggSelector, mySendersDataIsLoadingSelector } from './my-senders-selectors';
import { openSenderDetailsPane } from '../../common/actions/right-pane-action-creators';
import AgGridTableContainer from '../../table/ag-grid-table-container';
import ColumnFilterHeader from '../../table/filters/column-filter-header';
import EmptyWidget from '../empty-widget';
import LoadingSpinner from '../../common/components/loading-spinner';

export class MySenderTableContainer extends Component{
    componentDidMount(){
        this.fetchTheData();
    }

    componentDidUpdate( prevProps ){
        if( this.props.canvasDataParams !== prevProps.canvasDataParams ){
            this.fetchTheData();
        }
    }

    fetchTheData = () => {
        const { config, initializeMySendersWidget } = this.props;
        initializeMySendersWidget( config.id );
    }

    handleColumnToggle = ( columnId ) => {
        this.props.toggleWidgetTableColumn( this.props.config.id, columnId );
    }

    handleColumnReset = () => {
        this.props.resetWidgetTableColumn( this.props.config.id );
    }

    handleRowClick = ( row ) => {
        this.props.openSenderDetailsPane( row.senderId, row.name );
    }

    render(){
        const {
            config, exportToCSVSuccess, exportToCSVFailure, isActiveTable, isExportingGridToCSV, isLoading,
            senders
        } = this.props;

        const dataAutomationId = 'my-senders-table';

        if( isLoading ){
            return <LoadingSpinner />;
        }
        if( senders.length === 0 ){
            return <EmptyWidget
                text="You haven't identified any legimite sender for domains on this canvas."
                type="my-senders"
            />;
        }

        return (
            <>
                <ColumnFilterHeader
                    columnDefs={config.agGrid}
                    dataAutomationId={dataAutomationId}
                    description={ `${senders.length} senders` }
                    onColumnToggle={this.handleColumnToggle}
                    onColumnReset={this.handleColumnReset}
                    persistColumnFilters={[ 'name' ]}
                />
                <AgGridTableContainer
                    columnDefs={config.agGrid}
                    dataAutomationId={dataAutomationId}
                    rowClickHandler={this.handleRowClick}
                    rowData={senders}
                    exportToCSVSuccess={exportToCSVSuccess}
                    exportToCSVFailure={exportToCSVFailure}
                    exportCSVFileName="mySenders"
                    isExportingGridToCSV={isExportingGridToCSV}
                    tableType={`${TABLE_TYPES.SCROLLING} ${TABLE_TYPES.WIDGET_WITH_SUBTITLE} ${activeClass( isActiveTable )}`}
                    widgetId={config.id}
                />
            </>
        );
    }
}

MySenderTableContainer.propTypes = {
    canvasDataParams: PropTypes.object,
    config: PropTypes.shape( {
        id: PropTypes.number.isRequired,
    } ).isRequired,
    exportToCSVFailure: PropTypes.func.isRequired,
    exportToCSVSuccess: PropTypes.func.isRequired,
    initializeMySendersWidget: PropTypes.func.isRequired,
    isActiveTable: PropTypes.bool,
    isExportingGridToCSV: PropTypes.bool.isRequired,
    isLoading: PropTypes.bool.isRequired,
    openSenderDetailsPane: PropTypes.func,
    resetWidgetTableColumn: PropTypes.func.isRequired,
    senders: PropTypes.array,
    toggleWidgetTableColumn: PropTypes.func.isRequired,
};

/* istanbul ignore next */
function mapStateToProps( state, props ){
    return {
        isActiveTable: isActiveRightPaneSelector( state, 'senderDetails' ),
        isExportingGridToCSV: isExportingGridToCsvSelector( state, props ),
        isLoading: mySendersDataIsLoadingSelector( state ),
        senders: mySendersAggSelector( state ),
    };
}

const mapDispatchToProps = {
    exportToCSVFailure,
    exportToCSVSuccess,
    initializeMySendersWidget,
    openSenderDetailsPane,
    resetWidgetTableColumn,
    toggleWidgetTableColumn,
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)( MySenderTableContainer );
